// This file is deprecated and only used to move node_modules accessed in the
// sprockets asset pipeline to webpack entry points
// adding random string to force recompile:
// A998D3152224818D225A880A9B627F1FB4484DD7E408EACA1B243326ED4AA01B

// importing jquery using script-loader to mimic adding jQuery via a script tag
/* eslint-disable no-unused-vars,import/extensions */
import 'jquery/dist/jquery.min.js';
import 'leaflet/dist/leaflet.js';
import 'dexie/dist/dexie.min.js';
import 'intersection-observer/intersection-observer.js';
import '@strava/clio/dist/strava_analytics.min.js';
import '@strava/autotrack/autotrack.js';
import 'dropzone/dist/dropzone.js';
import 'blueimp-load-image/js/load-image.all.min.js';
import 'dropzone/dist/min/dropzone.min.css';

import { setPublicServiceEnv } from './utils/public-service-env';
import { devLog } from './utils/devUtils';

// Expose method on global scope that sets public keys that are commonly passed
// to 3rd party libs or tooling.
if (window.stravaPublicServiceEnv === undefined) {
  window.stravaPublicServiceEnv = setPublicServiceEnv;
}

devLog('loading global libraries');
